import { alpha } from '@mui/material';
export const useSponsorshipProfileStyles = () => {
    return {
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: (theme) => theme.palette.background.default,
            borderRadius: (theme) => theme.spacing(3),
            border: `1px solid ${(theme) => alpha(theme.palette.grey[500], 0.24)}`,
            backdropFilter: 'blur(20px)',
            overflow: 'hidden'
        },
        profileBackground: {
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            paddingBottom: (theme) => theme.spacing(2)
        },
        contactIcons: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: (theme) => theme.spacing(2)
        },
        contactIcon: {
            border: 'none'
        }
    };
};
